import React from 'react';

import Thumb from '../img/blogs/some-javascript-interview-questions.jpg';

const SomeJavaScriptInterviewQuestions2 = {
    id: 18, permalink: "some-javascript-interview-questions-2", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 13, 2020", categories: "JavaScript", title: "Some JavaScript Interview Questions Part 2", shortDesc: "When you want a Web Developer job, In the Interview you will be faced with JavaScript related questions. So, here are some most Interview Questions about JavaScript.", fullDesc: <>
        <p>When you want a <strong>Web Developer</strong> job, In the <strong>Interview</strong> you will be faced with <strong>JavaScript</strong> related questions. So, here are some most <strong>Interview Questions</strong> about <strong>JavaScript</strong>, that can help you in the <strong>Interview</strong>.</p>


        <h2>How would you verify a prime number?</h2>
        <p>A <strong>prime number</strong> is only <strong>divisible </strong>by itself and <code>1</code>. So, I will run a <strong>while loop</strong> and increase by <code>1</code> to check it is <strong>divisible</strong> by <strong>another number</strong> (Except 1 and that number) or not. If no number can't <strong>divisible</strong> that number it will return <code>true</code>.</p>
        <pre className="code">
            const isPrime = n => &#123; <br />
                &nbsp; let divisor = 2; <br />
                &nbsp; if (n % divisor == 0) return false; <br />
                &nbsp; else divisor++; <br /> <br />

                &nbsp; while (n > divisor) &#123; <br />
                    &nbsp;   if (n % divisor == 0) return false; <br />
                    &nbsp;   else divisor += 2; <br />
                &nbsp; &#125; <br />
                &nbsp; return true; <br />
            &#125; <br />
            console.log(isPrime(17)); <br />
            console.log(isPrime(15));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code> and <code className="output">false</code></p>


        <h2>How could you find all the prime factors of a number?</h2>
        <p>I will run a <strong>while loop</strong> and start <strong>dividing</strong> by <code>2</code> and if not <strong>divisible</strong> increase <strong>divider</strong> until done.</p>

        <pre className="code">
            const primeFactors = n => &#123; <br />
                &nbsp; let factors = [], divisor = 2; <br />
                &nbsp; while (n > 2) &#123; <br />
                    &nbsp;   if (n % divisor == 0) &#123; <br />
                        &nbsp;     factors.push(divisor); <br />
                        &nbsp;     n = n / divisor; <br />
                    &nbsp;   &#125; else divisor++; <br />
                &nbsp; &#125; <br />
                &nbsp; return factors; <br />
            &#125; <br />
            console.log(primeFactors(210));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">[ 2, 3, 5, 7 ]</code></p>


        <h2>How do you find the greatest common divisor of two numbers?</h2>
        <pre className="code">
            const greatestCommonDivisor = (a, b) => &#123; <br />
                &nbsp; let divisor = 2, greatestDivisor = 1; <br />

                &nbsp; if (a &lt; 2 || b &lt; 2) return 1; <br />

                &nbsp; while (a &gt;= divisor &amp;&amp; b &gt;= divisor) &#123; <br />
                    &nbsp;   if (a % divisor == 0 &amp;&amp; b % divisor == 0) greatestDivisor = divisor; <br />
                    &nbsp;   divisor++; <br />
                &nbsp; &#125; <br />
                &nbsp; return greatestDivisor; <br />
            &#125; <br />
            console.log(greatestCommonDivisor(24, 36));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">12</code></p>


        <h2>How would you remove duplicate members from an array?</h2>
        <p>I will start a <strong>while looping</strong> and keep an <strong>object/associated array</strong>. If I find a number for the first time, I will set its value to <code>true</code>. If I find a number that exists in an <strong>object</strong>, I will not insert it into the <strong>return array</strong>.</p>

        <pre className="code">
            const removeDuplicate = arr => &#123; <br />
                &nbsp; let exists = &#123;&#125;, outArr = [], elm; <br /><br />

                &nbsp; for (let i = 0; i &lt; arr.length; <br />
                    &nbsp;   elm = arr[i]; <br />
                    &nbsp;   if (!exists[elm]) &#123; <br />
                        &nbsp;     outArr.push(elm); <br />
                        &nbsp;     exists[elm] = true; <br />
                    &nbsp;   &#125; <br />
                &nbsp; &#125; <br />
                &nbsp; return outArr; <br />
            &#125; <br />
            console.log(removeDuplicate([1, 3, 1, 3, 5, 5, 3, 7, 5, 1]));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">[ 1, 3, 5, 7 ]</code></p>


        <h2>How would you reverse a string in JavaScript?</h2>
        <p>I will <strong>loop</strong> through the <strong>string</strong> and <strong>concatenate letters</strong> to a new <strong>string</strong>.</p>

        <pre className="code">
            const reverseString = str => str.split('').reverse().join(''); <br />
            console.log(reverseString("I am Wasek Bellah"));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">halleB kesaW ma I</code></p>


        <h2>How would you reverse words in a sentence?</h2>
        <p>I will check for <strong>whitespace</strong> and walk through the <strong>string</strong>. I will also check there multiple <strong>white-spaces</strong> are present or not. after that, I will <strong>reverse</strong> the <strong>string</strong>.</p>

        <pre className="code">
            const reverseWords = str => str.split(' ').reverse().join(' '); <br />
            console.log(reverseWords("I am Wasek Bellah"));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Bellah Wasek am I</code></p>


        <h2>How would you reverse a string in place? Ex: "I am Wasek Bellah" to "I ma kesaW halleB".</h2>
        <p>I will first <strong>reverse words</strong> and then <strong>reverse the string</strong>.</p>

        <pre className="code">
            const reverseInPlace = str => str.split(' ').reverse().join(' ').split('').reverse().join(''); <br />
            console.log(reverseInPlace("I am Wasek Bellah"));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">I ma kesaW halleB</code></p>


        <h2>How will you verify a word is a palindrome or not?</h2>
        <p>If a word <strong>reversed</strong> and it is the same as the previous word, it is called <strong>palindrome</strong>.</p>

        <pre className="code">
            const isPalindrome = str => &#123; <br />
                &nbsp; let revStr = str.split('').reverse().join(''); <br />
                &nbsp; return str == revStr; <br />
            &#125; <br />
            console.log(isPalindrome("radar")); <br />
            console.log(isPalindrome("randers"));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code> and <code className="output">false</code></p>


        <h2>Generate a random number between <code>1</code> to <code>6</code>? The number should be an integer.</h2>
        <p>I will use, <code>Math.random()</code> to generate <strong>random numbers</strong> and <code>Math.floor()</code> to make that <strong>number integer</strong>.</p>

        <pre className="code">
            const oneToSix = 1 + Math.floor(Math.random() * 6); <br />
            console.log(oneToSix);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">1</code> to <code className="output">6</code> random integer number.</p>


        <h2>Count Total number of zeros from 1 upto n?</h2>
        <p><strong>Number</strong> of <code>0</code> would be <code>11 (0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100)</code>. Here <code>100</code> has two <code>0</code>.</p>

        <p>If I have <strong>numbers</strong> from <code>1</code> to <code>60</code> the value is <code>6</code>. Just <code>60</code> divided by <code>10</code>. However, if the value is <code>100</code>, the value is <code>11</code>. I will get <code>100/10 = 10</code> and <code>10/10 = 1</code>, <code>10+1 = 11</code>.</p>

        <pre className="code">
            const countZero = n => &#123; <br />
                &nbsp; let count = 0; <br />
                &nbsp; while (n > 0) &#123; <br />
                    &nbsp;   count += Math.floor(n / 10); <br />
                    &nbsp;   n = n / 10; <br />
                &nbsp; &#125; <br />
                &nbsp; return count; <br />
            &#125; <br />
            console.log(countZero(1000));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">111</code></p>
    </>
};
export default SomeJavaScriptInterviewQuestions2;